import { StateViewModel } from '../../models/viewModels/StateViewModel';
import { v4 as uuid } from 'uuid';
import { ExclusiveComponentsConstants } from '../ExclusiveComponentsConstants';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { ContentActionViewModel } from '../../models/viewModels/ContentActionViewModel';
import { ActionViewModel } from '../../models/viewModels/ActionViewModel';
import { ActionType } from '../../models/Action';
import { SendRawMessageActionSettings } from '../../models/SendRawMessageActionSettings';
export const getNewBlipChatCopyAndPasteState = (title, content) => {
    return new StateViewModel({
        id: `${ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_PREFIX}${uuid()}`,
        root: false,
        $invalid: false,
        stateVersion: ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_VERSION,
        $contentActions: [
            new ContentActionViewModel({
                action: new ActionViewModel({
                    type: ActionType.SendRawMessage,
                    $typeOfContent: 'raw-content',
                    settings: new SendRawMessageActionSettings({
                        type: ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE,
                        rawContent: JSON.stringify(content),
                    }),
                }),
            }),
        ],
        $title: title,
        $defaultOutput: new OutputViewModel({ stateId: 'fallback' }),
    });
};
